import type { ComponentPropsWithoutRef, CSSProperties, Ref } from 'react';
import { cx } from '../../utils/cx';
import { useFieldProps } from '../FormField/FormField';
import s from './TextArea.module.css';

export type TextAreaProps = ComponentPropsWithoutRef<'textarea'> & {
  ref?: Ref<HTMLTextAreaElement>;
  /** Minimum visible rows; it grows with content (field-sizing) up to `maxRows`. */
  minRows?: number;
  maxRows?: number;
};

export function TextArea({
  minRows,
  maxRows = 12,
  rows,
  className,
  style,
  ...rest
}: TextAreaProps) {
  const props = useFieldProps(rest);
  // The height comes from CSS, so a plain `rows` would be silently ignored. Treat it as
  // `minRows` instead: the prop a caller reaches for first shouldn't quietly do nothing.
  const min = minRows ?? rows ?? 3;
  return (
    <textarea
      className={cx(s.textarea, className)}
      rows={min}
      style={{ ...style, '--min-rows': min, '--max-rows': maxRows } as CSSProperties}
      {...props}
    />
  );
}
